import { FC } from 'react'

import { ExtendTextFieldProps } from 'components/form-field/TextFormField/types'

import { MaskedTextFormField } from './MaskedTextFormField'

export const AnyNumberFormField: FC<ExtendTextFieldProps> = (props) => {
  return <MaskedTextFormField mask={/^\d*$/} {...props} />
}
